import { defineMessages } from 'react-intl'

export default defineMessages({
  aiSummary: {
    id: 'patientDossier.aiSummary',
    defaultMessage: 'AI Summary'
  }
})
